import { SearchResult } from '@shared/models/search/search-result';
import { CardPreferenceState } from '@shared/shared/modules/card/models/card';
import { PreferencesActionTypes, TogglePreferenceAction } from '@shared/store/preferences/actions';
import { EntertainmentSearchState } from '.';
import * as fromActions from '../actions/entertainment-search.actions';

export const initialState: EntertainmentSearchState = {
  results: {
    isLoading: false,
    loaded: false,
    items: null,
    totalItems: null,
    latestPage: null,
    lastFilters: [],
    canLoadMore: false,
    hasFollowAnchor: false,
  },
  preferences: {},
};

export function reducer(state = initialState, action: fromActions.MemberEventsSearchActions | TogglePreferenceAction) {
  switch (action.type) {
    case fromActions.GET_RESULTS:
      return {
        ...state,
        results: {
          ...state.results,
          error: undefined,
          isLoading: true,
          lastFilters: action.payload.selectedFilters,
          lastPhrase: action.payload.searchPhrase,
          loaded: false,
          canLoadMore: action.payload.removeOldResults ? false : state.results.canLoadMore,
          items: action.payload.removeOldResults ? [] : state.results.items,
        },
      };

    case fromActions.GET_RESULTS_SUCCESS: {
      const preferences: CardPreferenceState = {};
      let resultItems =
        state.results.items && !action.payload.removeOldResults
          ? state.results.items.concat(action.payload.results)
          : action.payload.results;

      let tourAnchorSet: boolean;

      resultItems = resultItems.map((item) => {
        if (item.followButton) {
          preferences[item.id] = item.followButton.preferred;
        }

        if (!tourAnchorSet && item.followButton && !item.followButton.favourite) {
          tourAnchorSet = true;
          return { ...item, tourAnchorId: 'preferences.follow-artist' };
        }

        return item;
      });

      return {
        ...state,
        results: {
          isLoading: false,
          loaded: true,
          lastPhrase: action.payload.searchPhrase,
          lastFilters: action.payload.selectedFilters,
          latestPage: action.payload.page,
          canLoadMore: action.payload.canLoadMore,
          totalItems: action.payload.totalResults,
          items: resultItems,
          hasFollowAnchor: tourAnchorSet,
        },
        preferences: { ...state.preferences, ...preferences },
      };
    }
    case fromActions.GET_TEN_EVENTS:
      return {
        ...state,
        results: {
          ...state.results,
          error: undefined,
          isLoading: true,
          loaded: false,
          items: [],
        },
      };

    case fromActions.GET_TEN_EVENTS_SUCCESS: {
      return {
        ...state,
        results: {
          isLoading: false,
          loaded: true,
          items: action.results,
        },
      };
    }

    case fromActions.GET_RESULTS_FAILURE:
      return {
        ...state,
        results: {
          ...state.results,
          error: action.payload.error,
          isLoading: false,
        },
      };

    case PreferencesActionTypes.TOGGLE_PREFERENCE: {
      const preferences: CardPreferenceState = {};

      state.results.items?.forEach((item: SearchResult) => {
        let idToCheck: string;

        if (item.followButton) {
          idToCheck = !item.followButton.favourite
            ? item.followButton.product?.id?.toString()
            : `${item.followButton?.product?.id}-${item.followButton.product?.type}`;
        }

        if (idToCheck && idToCheck === action.id) {
          preferences[item.id] = !state.preferences[item.id];
        }
      });

      return {
        ...state,
        preferences: { ...state.preferences, ...preferences },
      };
    }

    default:
      return state;
  }
}
